<template>
  <div class="container page service-frame-page">
    <div class="header">
      <van-nav-bar :title="$t('my.online_service')" class="nav-bar">
        <template #left>
          <button class="nav-back" type="button" aria-label="Back" @click="back()">
            <van-icon name="arrow-left" />
          </button>
        </template>
      </van-nav-bar>
    </div>
    <div class="ifrmae_page">
      <iframe title="Victoria Dating Club customer service" width="100%" height="100%" frameborder="0" id="iframe_web" :src="this.$store.getters.getBaseInfo.kefu !==undefined ?this.$store.getters.getBaseInfo.kefu:'https://hao.360.com/'"></iframe>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
    };
  },
  methods: {
    back(){
      return window.history.back();
    }
  },
  created() {

  },
  mounted(){
    /**
     * iframe-宽高自适应显示
     */
    const oIframe = document.getElementById('iframe_web');
    const deviceHeight = document.documentElement.clientHeight;
    oIframe.style.height = (Number(deviceHeight)-65) + 'px'; //数字是页面布局高度差
  }
};
</script>

<style lang='less' scoped>
@import "../../assets/css/base.css";
.service-frame-page {
  padding-bottom: max(0.24rem, env(safe-area-inset-bottom));
  background: transparent;
}

.service-frame-page .nav-back {
  display: inline-flex;
  width: 0.88rem;
  height: 0.88rem;
  margin-left: -0.2rem;
  align-items: center;
  justify-content: center;
  color: var(--victoria-text);
  background: transparent;
  border: 0;
  border-radius: 50%;
}

.service-frame-page .ifrmae_page {
  flex: 1;
  margin: 0.28rem;
  overflow: hidden;
  background: var(--victoria-surface);
  border: 1px solid var(--victoria-border);
  border-radius: 0.42rem;
  box-shadow: var(--victoria-shadow);
}

.service-frame-page iframe {
  display: block;
  background: #fff;
}
</style>
